import React, {useContext} from "react";
import withTranslator from "../Translator/withTranslation";
import styled from '@emotion/styled';
import { CurrencyContext } from "../Context/Currency";
import { CountdownSearchResult } from "./CountdownSearchResult";
import { LocaleContext  } from "../Context/Locale";

const Slashthrough = styled.div `
    margin-bottom:5px;
`
const PriceHolder = styled.div `
    align-self: flex-end;
`;
const PriceHolderNoDiscount = styled.div `
    @media (min-width: 499px) {
        margin-top: 1em;
    }
`;
const VillaTile = styled.div `
    flex-direction:column;
`;

const Button = styled.a `
    text-align: center;
    font-size: 1.2em;
    text-transform: uppercase;
    margin-top:1em;
`
const CurrencyData = {
    'EUR': '€',
    'GBP': '£',
    'CHF': 'CHF',
    'SEK': 'SEK',
    'NOK': 'NOK',
    'DKK': 'DKK',
    'USD': '$'
};
 const PriceWrapper = styled.div `

 `;
const VillaTilePriceCTAComponent = (props) => {
    const localeContext = useContext(LocaleContext);
    const currencyContext = useContext(CurrencyContext);

    const handleClick = (event) => {
        event.preventDefault();
        if (props.sendClickEvent) {
            props.sendClickEvent();
        }
        window.open(props.data.villaUri.replace('http:', ''), '_blank');
    }

    const getPrice = (conversionRate) => {
        var base = (props.data.priceSum) ? (props.data.priceSum + props.data.extrasIncludedPrice)*conversionRate : props.data.minPrice * conversionRate;
        return base.toFixed(2);
    }

    const getSlashThrough = (conversionRate) => {
        var base = 0;
        if (props.data.priceBeforeDiscount > props.data.priceSum) {
            var base = (props.data.priceBeforeDiscount) ? (props.data.priceBeforeDiscount + props.data.extrasIncludedPrice) *conversionRate : props.data.minPrice * conversionRate;
        }
        return base.toFixed(2);
    }

    var containerClassName = !props.mobile && !props.tablet ? 'flex justify-sbetween' : '';
    containerClassName += props.className ? ' '+props.className : '';

    var buttonClassName = 'btn btn-secondary';
    buttonClassName += props.mobile || props.tablet ? ' btn-block' : '';

    const t = props.t;
    let slashThrough = getSlashThrough(currencyContext.conversionRate);
    var formatter =  new Intl.NumberFormat(typeof window !== 'undefined' ? window.CvrmLocale : localeContext.locale , {style: 'currency', currency: currencyContext.code ? currencyContext.code : 'EUR' , minimumFractionDigits: 2});
    let price = getPrice(currencyContext.conversionRate);

   return (
            <VillaTile className={containerClassName}>
                <div className="flex align-items-end">
                {!props.data.priceSum ?
                    <div className="font-70 line-height-sm grey1 mr-2">
                        <div className="ucfirst">{t('from')}/</div>
                        <div>{t('perday')}</div>
                    </div>
                :''}
                    <div className="font-w600 font-180 width-100">
                        {  (props.data.discountEndsAt && slashThrough > 0) ?
                                (
                                    <PriceWrapper className="width-100 flex justify-sbetween mb-0">
                                        <PriceHolder className="align-self-start">
                                            <Slashthrough className="slashthrough font-60 text-left">{formatter.format(slashThrough)}</Slashthrough>
                                            <a href={props.data.villaUri}>{formatter.format(price)}</a>
                                        </PriceHolder>
                                        <CountdownSearchResult className="align-self-end" { ...props} />
                                    </PriceWrapper>
                                )
                            : ( <PriceHolderNoDiscount><a href={props.data.villaUri}>{formatter.format(price)}</a></PriceHolderNoDiscount> )
                        }
                    </div>
                </div>
                <Button href={props.data.villaUri.replace('http:', '')} onClick={event => handleClick(event)} className={buttonClassName} target="_blank">{t('showthisvilla')} &rsaquo;</Button>
            </VillaTile>
        );
}

export const VillaTilePriceCTA = withTranslator(VillaTilePriceCTAComponent);
